import { cva } from '@/styled-system/css';

export const headingRecipe = cva({
  base: {
    color: 'text.neutral',
  },
  variants: {
    fontFamily: {
      'heading': { fontFamily: 'heading' },
      'heading-alt': { fontFamily: 'heading-alt' },
    },
    textStyle: {
      'heading-xl': { textStyle: 'heading-xl' },
      'heading-lg': { textStyle: 'heading-lg' },
      'heading-md': { textStyle: 'heading-md' },
      'heading-sm': { textStyle: 'heading-sm' },
      'heading-xs': { textStyle: 'heading-xs' },
      'body-lg-bold': { textStyle: 'body-lg-bold' },
      'responsive.heading-xl': { textStyle: 'responsive.heading-xl' },
      'responsive.heading-lg': { textStyle: 'responsive.heading-lg' },
      'responsive.heading-md': { textStyle: 'responsive.heading-md' },
      'responsive.heading-sm': { textStyle: 'responsive.heading-sm' },
      'responsive.heading-xs': { textStyle: 'responsive.heading-xs' },
      'responsive.body-lg-bold': { textStyle: 'responsive.body-lg-bold' },
    },
  },
});
